// Normalizador PT-BR-aware pra título-case de endereços e nomes.
// Substitui a antiga regra global `text-transform: capitalize` no CSS, que
// (a) só pintava o display sem alterar o `.value` enviado pro DB, e
// (b) capitalizava preposições erradas em PT-BR ("Rua Sete De Setembro").
//
// Aplicado via onBlur nos campos de endereço (rua, bairro, cidade,
// complemento, nome do cliente). NÃO usar em: PIX, CPF, telefone, email,
// número, CEP, nome de produto/loja (esses têm capitalização autoral ou
// formato rígido).
//
// Idempotente: rodar 2x dá o mesmo resultado — pode ser reusado como
// migração one-shot do legado se necessário.

// Conectores PT-BR que devem ficar em minúsculo no MEIO do texto, mas
// capitalizam se forem a primeira palavra ("De Souza Lima" no começo
// é nome). Lista compacta — mais conectores adicionam pouco e geram
// regressões em palavras curtas legítimas (ex: "Eli", "Os").
const CONNECTORS = new Set([
  "de", "da", "do", "das", "dos",
  "e", "em", "no", "na", "nos", "nas",
  "a", "o", "as", "os",
]);

// Números puros e ordinais ("7", "1º", "2ª", "10°"). Devem ficar como vieram.
const NUMBER_RE = /^\d+[ºª°]?$/;

function capWord(w: string, isFirst: boolean): string {
  if (!w) return w;
  if (NUMBER_RE.test(w)) return w;
  const lower = w.toLocaleLowerCase("pt-BR");
  if (!isFirst && CONNECTORS.has(lower)) return lower;
  return lower.charAt(0).toLocaleUpperCase("pt-BR") + lower.slice(1);
}

export function titleCasePtBR(input: string | null | undefined): string {
  if (!input) return "";
  const trimmed = input.trim();
  if (!trimmed) return "";
  return trimmed
    .split(/\s+/)
    .map((word, i) =>
      // Hífen é tratado como separador interno: "santo-andré" → "Santo-André".
      // Cada subpart é capitalizada (primeira é tratada como "primeira palavra"
      // só se for o primeiro token da string).
      word
        .split("-")
        .map((sub, j) => capWord(sub, i === 0 && j === 0))
        .join("-"),
    )
    .join(" ");
}

/** Sentence case pra EXIBIÇÃO de nome de categoria: "pizza"→"Pizza",
 * "MARMITA"→"Marmita". Mesma regra da vitrine pública (decisão do Pedro,
 * 10/08/2026 — desistiu de preservar tudo-maiúsculo). Só exibição, nunca
 * gravação. */
export function sentenceCasePtBR(input: string | null | undefined): string {
  const t = (input || "").trim();
  if (!t) return t;
  return t.charAt(0).toLocaleUpperCase("pt-BR") + t.slice(1).toLocaleLowerCase("pt-BR");
}
